import i18n from '../i18n';
import { FormFieldType, FormType } from '../types/apiResponse/form';
import { SmartsellEnv } from './enums';

export const visitStates = (): { [key: string]: string } => ({
  svi: i18n.t('noVisit'),
  sve: i18n.t('noSale'),
  vrf: i18n.t('visitOutsideTheRadius'),
  v: i18n.t('sale'),
});

export const formOpeningLocations = (): { [key: number]: string } => ({
  [SmartsellEnv.visitScreenCard]: i18n.t('visitScreenCard'),
  [SmartsellEnv.visitButton]: i18n.t('visitButton'),
  [SmartsellEnv.customerListWhenOrdering]: i18n.t('customerListWhenOrdering'),
  [SmartsellEnv.orderScreen]: i18n.t('orderScreen'),
  [SmartsellEnv.saveOrderButton]: i18n.t('saveOrderButton'),
  [SmartsellEnv.addOrderItemScreen]: i18n.t('addOrderItemScreen'),
  [SmartsellEnv.saveOrderItemButton]: i18n.t('saveOrderItemButton'),
  [SmartsellEnv.newCustomerButton]: i18n.t('newCustomerButton'),
});

export const formFieldTypes: Record<FormFieldType, string> = {
  t: i18n.t('text'),
  n: i18n.t('numeric'),
  mi: i18n.t('multipleChoice'),
  me: i18n.t('singleChoice'),
  img: i18n.t('image'),
  cpf: i18n.t('cpf'),
  cnpj: i18n.t('cnpj'),
  phone_br: i18n.t('phone'),
  email: i18n.t('email'),
  mobile_phone_br: i18n.t('mobilePhone'),
  currency_br: i18n.t('currencyBr'),
  website: i18n.t('website'),
  date_br: i18n.t('dateBr'),
  datetime_br: i18n.t('datetimeBr'),
  hour_and_minute: i18n.t('hourAndMinute'),
  br_uf: i18n.t('br_uf'),
  tab_price: i18n.t('tabPrice'),
  payment_condition: i18n.t('paymentCondition'),
  payment_method: i18n.t('paymentMethod'),
  full_address: i18n.t('fullAddress'),
  billing_unit: i18n.t('billingUnit'),
  company_name: i18n.t('companyName'),
  trade_name: i18n.t('tradeName'),
  cgc_cpf: i18n.t('cgcCpf'),
};

export const formTypes: Record<FormType, string> = {
  GENERIC: i18n.t('generic'),
  NEW_CUSTOMER: i18n.t('newCustomer'),
};
